import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { Layout } from '../Layout';

export interface IRealtyValuationProps {
  title: string;
  content: React.ReactElement;
}

export const RealtyValuation: React.VFC<IRealtyValuationProps> = props => {
  const { content, title } = props;

  return (
    <Layout testId="RealtyValuation">
      <div className={styles['title']}>
        <UIHeading1 as="h2">{title}</UIHeading1>
      </div>
      {content}
    </Layout>
  );
};
